export default __webpack_public_path__ + "static/media/smallstainedglasswindow.49be01e6.png";